(function ($) {
    "use strict";

    window.klaroConfig = {
        acceptAll: true,
        translations: {
            en: {
                privacyPolicyUrl: '/en/service/privacy-policy/',
                consentNotice: {
                    description: 'When you use our website, data is collected via cookies. Some of these cookies are technically necessary to ensure the functionality of the website. Other cookies are used for website analysis, which help us to constantly optimize our offer. You can decide here whether you agree to the website analysis.',
                },
                purposes: {
                    analytics: 'Analytics',
                    embeds: 'Third-party content',
                    marketing: 'Marketing',
                },
                matomo: {
                    description: 'Collecting visitor statistics',
                },
                linkedIn: {
                    description: 'Analysis of marketing campaigns',
                },
                twitter: {
                    title: 'Twitter',
                    description: 'Integration of tweets',
                },
                youTube: {
                    title: 'YouTube',
                    description: 'Integration of videos',
                },
                vimeo: {
                    title: 'Vimeo',
                    description: 'Integration of videos',
                },
                ok: 'Accept',
                decline: 'Decline',
                acceptSelected: 'Accept only selected',
            },
            de: {
                privacyPolicyUrl: '/de/service/datenschutz/',
                consentNotice: {
                    description: 'Bei Nutzung unserer Website werden Daten über Cookies erhoben. Dabei handelt es sich zum einen um technisch notwendige, um die Funktionalität der Website zu gewährleisten. Zum anderen handelt es sich um Cookies zur Websiteanalyse, die uns helfen, das Angebot stets zu optimieren. Sie können hier entscheiden, ob Sie der Websitanalyse zustimmen.',
                },
                purposes: {
                    analytics: 'Besucherstatistiken',
                    embeds: 'Inhalte von Drittanbietern',
                    marketing: 'Marketing',
                },
                matomo: {
                    description: 'Sammeln von Besucherstatistiken',
                },
                linkedIn: {
                    description: 'Auswertung von Marketing-Kampagnen',
                },
                twitter: {
                    title: 'Twitter',
                    description: 'Einbindung von Tweets',
                },
                youTube: {
                    title: 'YouTube',
                    description: 'Einbindung von Videos',
                },
                vimeo: {
                    title: 'Vimeo',
                    description: 'Einbindung von Videos',
                },
                ok: 'Akzeptieren',
                decline: 'Ablehnen',
                acceptSelected: 'Nur ausgewählten zustimmen',
            },
        },
        services: [{
            name: 'matomo',
            title: 'Matomo',
            purposes: ['analytics'],
            cookies: [
                /^_pk_/,
            ],
        }, {
            name: 'linkedIn',
            title: 'LinkedIn',
            purposes: ['marketing'],
        }, {
            name: 'twitter',
            title: 'Twitter',
            purposes: ['embeds'],
        }, {
            name: 'youTube',
            title: 'YouTube',
            purposes: ['embeds'],
        }, {
            name: 'vimeo',
            title: 'Vimeo',
            purposes: ['embeds'],
        }],
    };

    $(function () {
        $('[data-widget="embed-placeholder"]').each(function () {
            let $placeholder = $(this),
                platform = $placeholder.data('platform'),
                consentManager = klaro ? klaro.getManager() : null,
                hasPermission = consentManager && consentManager.getConsent(platform),
                embedCode = $placeholder.data('embedCode'),
                consentWatcher, replaced = false;

            function replace() {
                $placeholder.replaceWith(embedCode);
                replaced = true;
                if (consentWatcher && consentManager) {
                    consentManager.unwatch(consentWatcher);
                }
            }

            if (hasPermission) {
                replace();
            } else {
                $placeholder.on('click', '[data-action="accept"]', function (event) {
                    if (consentManager) {
                        consentManager.updateConsent(platform, true)
                        consentManager.saveAndApplyConsents();
                    } else {
                        replace();
                    }

                    event.preventDefault();
                });

                consentWatcher = {
                    update: function (obj, name, data) {
                        if ('consents' === name && true === data[platform]) {
                            replace();
                        }
                    }
                };
                consentManager.watch(consentWatcher);
            }
        });

        $('body').on('click', '.cookie-settings', function (event) {
            if ('undefined' !== typeof klaro) {
                event.preventDefault();

                klaro.show();
            }
        });
    });
})(jQuery);
